'use client';

import { c as _c } from "react/compiler-runtime";
import { useAccess } from '@repo/auth';
import { permissions } from '@repo/permissions';
import { ResponsiveSheet, ResponsiveSheetContent, ResponsiveSheetHeader, ResponsiveSheetTitle } from '@repo/ui/components';
import { File } from '@repo/ui/icons';
import { useCreateCompanySheet } from './context';
import { CreateCompanyForm } from './form';
export const CreateCompanySheet = () => {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      match: "any",
      permissions: [permissions.companies.create]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    allowed
  } = useAccess(t0);
  const {
    closeCreateCompanySheet,
    formKey,
    isOpen
  } = useCreateCompanySheet();
  if (!allowed) {
    return null;
  }
  let t1;
  if ($[1] !== closeCreateCompanySheet || $[2] !== isOpen) {
    t1 = open => !open && isOpen && closeCreateCompanySheet();
    $[1] = closeCreateCompanySheet;
    $[2] = isOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ResponsiveSheetHeader className="p-0" data-sentry-element="ResponsiveSheetHeader" data-sentry-source-file="sheet.tsx"><ResponsiveSheetTitle className="flex items-center gap-3 text-3xl font-bold" data-sentry-element="ResponsiveSheetTitle" data-sentry-source-file="sheet.tsx"><File data-sentry-element="File" data-sentry-source-file="sheet.tsx" /> New company</ResponsiveSheetTitle></ResponsiveSheetHeader>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== formKey || $[6] !== isOpen) {
    t3 = isOpen ? <CreateCompanyForm key={formKey} /> : null;
    $[5] = formKey;
    $[6] = isOpen;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <ResponsiveSheetContent className="gap-8 overflow-y-auto p-6 max-lg:w-full! sm:max-w-sm" data-sentry-element="ResponsiveSheetContent" data-sentry-source-file="sheet.tsx">{t2}{t3}</ResponsiveSheetContent>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isOpen || $[11] !== t1 || $[12] !== t4) {
    t5 = <ResponsiveSheet onOpenChange={t1} open={isOpen} data-sentry-element="ResponsiveSheet" data-sentry-component="CreateCompanySheet" data-sentry-source-file="sheet.tsx">{t4}</ResponsiveSheet>;
    $[10] = isOpen;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};